import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg className={styles["myhouse_setting_drag"] || "myhouse_setting_drag"} xmlns="http://www.w3.org/2000/svg" width="24" height="10" {...props}><path d="M0 0h24v1.5H0zm0 4h24v1.5H0zm0 4h24v1.5H0z" fill="#C8CCD3" fillRule="evenodd" /></svg>);